import { Icon } from "./Icon.tsx";

/** "Pick on the map" — a crosshair/target, the universal "click a point to choose it" affordance. Used by LongitudinalProfileDialog.tsx's own start/end node pickers. */
export function TargetIcon() {
  return (
    <Icon>
      <circle cx="12" cy="12" r="7" />
      <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
      <path d="M12 2v4M12 18v4M2 12h4M18 12h4" />
    </Icon>
  );
}
